import React, { Component } from "react";
import Wix from "Wix";
import Moment from "moment";
import parameters from "../../../config/parameters";
import Tooltip from "../driveItemThumbnail/TooltipsPage";
import {getFileByFileId} from '../../api/GoogleDriveApi';

class DriveItemTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: props.item ? props.item : null,
      clicked: false,
      displayIcon: true,
      displayOwner: true,
      displayLastModified: true,
      filePopupPreview: true,
      isPublic:true,
      hover:false
    };
    this.openItem = this.openItem.bind(this);
    this.renderItemFullScreen = this.renderItemFullScreen.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    if(props.loadItem)
      this.getFile(props.activeFileId);
  }
  ////////
  onMouseEnter(){
    this.setState({ hover: true });
  }
  onMouseLeave(){
    this.setState({ hover: false });
  }
  //////////

  updateState(data) {
    if (data) {
      if (
        (data.displayIcon === false || data.displayIcon === true) &&
        data.displayIcon !== this.state.displayIcon
      )
        this.setState({ displayIcon: data.displayIcon });
      if (
        (data.displayOwner === false || data.displayOwner === true) &&
        data.displayOwner !== this.state.displayOwner
      )
        this.setState({ displayOwner: data.displayOwner });
      if (
        (data.displayLastModified === false ||
          data.displayLastModified === true) &&
          data.displayLastModified !== this.state.displayLastModified
      )
        this.setState({ displayLastModified: data.displayLastModified });
      if (
        (data.filePopupPreview === false || data.filePopupPreview === true) &&
        data.filePopupPreview !== this.state.filePopupPreview
      )
        this.setState({ filePopupPreview: data.filePopupPreview });
    }
  }

  componentDidMount() {

    Wix.Styles.getStyleParams(style => {
      this.updateState(style.booleans);
    });

    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
      this.updateState(style.booleans);
    });
    this.deviceType = Wix.Utils.getDeviceType();

  }

    componentWillReceiveProps(newProps) {
        if(newProps.loadItem) {
          this.getFile(newProps.activeFileId);
        } else {
          this.setState({
              item: newProps.item,
              signal: newProps.signal
          });
        }

    }

    /**
     * load file details
     *
     */
    getFile(fileId) {
      getFileByFileId(fileId ? fileId : this.state.defaultFile, (item) => {
        this.setState({item: item})
      },false)
    }

    /**
     * Open item selected
     */
    openItem() {
        //!this.state.signal &&
        this.state.item.mimeType === parameters['TYPE_FOLDER'] ?
            this.props.openFolder() :
            this.setState({clicked: !this.state.clicked});
    }
    /**
     * Render item selected on full screen
     * @param {boolean} closeButtonEnabled if display close button
     */
    renderItemFullScreen(closeButtonEnabled) {
      let padding = Wix.Utils.getViewMode() === "preview" ? 280 : 112;
      let paddingLeft  = 0;
      let paddingTop  = 0;
      let maxWidth = 795;
      let mobileScreen = 507.5;
      let mobileWidth = 319;
      let widthEditFiles = 1600;
      let maxHeight = window.outerHeight - padding;
      let src = this.state.item.embedLink;
      src = src.replace(/ *a\/[^/]*\/ */g, "");
      let islong = this.state.item.imageMediaMetadata || this.state.item.videoMediaMetadata
      let screen = this.deviceType === "mobile" ? mobileScreen : window.outerHeight - padding;
      var onClose = () => {
          this.setState({clicked: !this.state.clicked});
      };
      if (this.state.item.mimeType.includes('google')) {
          let src = this.state.item.alternateLink;
          src = src.replace(/ *a\/[^/]*\/ */g, "");
          var win = window.open(src, '_blank');
          win.focus();
          return;
      }
      if (this.state.item.mimeType.includes('image') && !this.state.item.mimeType.includes('svg')) {
        let porp = islong ? islong.rotation || this.deviceType === "mobile" ? islong.width/screen : islong.height/screen : "";
        maxHeight = islong ? islong.height > window.outerHeight ?islong.rotation || this.deviceType === "mobile" ? Math.round(islong.width/porp) : Math.round(islong.height/porp):islong.height: "" ;
        maxWidth = islong ? islong.width > window.outerWidth ? islong.rotation || this.deviceType === "mobile" ? Math.round(islong.height/porp) : Math.round(islong.width/porp):islong.width: "" ;
        if(this.deviceType === "mobile"){
           maxWidth = maxWidth > mobileWidth ? mobileWidth : maxWidth;
           let height = islong.height > screen ? mobileWidth * (islong.rotation!== 0 ? (islong.width/islong.height):(islong.height/islong.width)):islong.height;
           let width = islong.width > mobileWidth ? mobileScreen * (islong.rotation!== 0 ? (islong.height/islong.width):(islong.width/islong.height)):islong.width;
           paddingTop = screen < height ? 0 : (screen - height)/2;
           paddingLeft = width < mobileWidth ? (mobileWidth - width)/2 : 0;
        }
        src = `https://lh3.googleusercontent.com/u/0/d/${this.state.item.id}=w${maxWidth}-h${maxHeight}`;
      }
      if(this.state.item.mimeType.includes('video'))
       {
        if(this.deviceType === "mobile") {
           let width = islong.height > islong.width ?mobileWidth * (islong.height/islong.width): mobileScreen * (islong.width/islong.height) ;
           let height= islong.height > islong.width ? mobileScreen * (islong.width/islong.height) : mobileWidth * (islong.height/islong.width);
               paddingTop = screen < height ? 0 : (screen - height)/2;
               paddingLeft = width < mobileWidth ? (mobileWidth - width)/2 : 0 ;
       }
        else maxWidth =  1440;
      }
      if(
          this.state.item.mimeType.includes('audio')||
          this.state.item.mimeType === parameters['TYPE_EXE']||
          this.state.item.mimeType === parameters['TYPE_CRT']
        ) {
              maxHeight = 150;
              maxWidth = 440;
          }
          if(this.state.item.mimeType === parameters['TYPE_FORM']){
              maxWidth = 640;
       }
       if(this.state.item.mimeType === parameters['TYPE_SLIDE']||
          this.state.item.mimeType.includes('document')||
          this.state.item.mimeType.includes('sheet')||
          this.state.item.mimeType.includes('drawing')){
                maxWidth = this.state.item.mimeType === parameters['TYPE_SLIDE'] ? 1548 :this.state.item.mimeType.includes('sheet')||   this.state.item.mimeType.includes('drawing') ? widthEditFiles : maxWidth;
          }
       if (this.deviceType === "mobile") {
        let uri_enc = encodeURIComponent(src);
        const popupUrl = window.location.protocol + "//" + window.location.host + `/widget/popup/${uri_enc}/${paddingTop}/${paddingLeft}/mobile`;
        let position =  {origin: Wix.WindowOrigin.FIXED, placement: Wix.WindowPlacement.CENTER}
        if(closeButtonEnabled) {
            Wix.openPopup(popupUrl,'100%','100%', position, onClose,Wix.Theme.BARE);
            return null;
        }
      }
      else if(closeButtonEnabled && this.deviceType === "desktop") {
        let uri_enc = encodeURIComponent(src);
        const popupUrl = window.location.protocol + "//" + window.location.host + `/widget/popup/${uri_enc}/${maxHeight}/${maxWidth}/desktop`;
        let position =  {origin: Wix.WindowOrigin.FIXED , placement: Wix.WindowPlacement.CENTER_LEFT}
         Wix.openPopup(popupUrl , '100%','100%', position, onClose ,Wix.Theme.BARE);
          return null;
        }

    }
    renderDetails() {

      if (!this.state.item)
        return <div/>
      const dateTime = this.state.item.modifiedDate;
      const iscurrentDate =
          Moment(dateTime).isSame(new Date(), "day")
            ? Moment(dateTime).format("HH:mm A")
            : Moment(dateTime).format("MMM D");
        return (
          <div className="display-title">
            <div className="title">
                <div className="sub-title">
                    {this.state.displayIcon ? (
                      <div className='div-icon-signal'>
                      <img
                        alt="icon"
                        src={this.state.item.iconLink}
                        className="icon-item"
                      />
                       </div>
                    ) : (
                     null
                    )}
                  <div className={"name " + (this.state.displayIcon ? "name-margin" :"")}>
                    <Tooltip text={this.state.item.title} />
                  </div>
                </div>
                {this.state.displayOwner ? (
                  <div className="owner">
                   <Tooltip text={this.state.item.owners[0].displayName}/>
                  </div>
                ) : null}
              </div>
              <div className={"date " + (this.state.displayIcon? "date-signal" :"")}>
                {this.state.displayLastModified
                  ? `Last modified on ${iscurrentDate}`
                  : null}
              </div>
          </div>
        )
    }
    render() {
        return <div />;
    }

}

export default DriveItemTemplate;




// WEBPACK FOOTER //
// ./src/widget/components/driveItemTemplate/DriveItemTemplate.js